<div class="ui-g ui-fluid">
  <div class="background ui-g-12">
      <div class="ui-g-12">
        <h2 class="title">{{this.titleContact}}</h2>
        <h3 class="subTitle">{{this.subTitleContact}} </h3>
      </div>
  </div>
  <div class="ui-g-12 ui-md-10 ui-lg-9" style="display: block; align-items: center; margin: 0 auto;">
    <div class="ui-g-12" style="padding-bottom: 0; padding-top: 3%;">
        <p-selectButton [options]="types" [(ngModel)]="selectedType" (click)="test($event)"  ></p-selectButton>
    </div>
    <div #local *ngFor="let contact of contacts; let i = index" >
      <div *ngIf="contact.typeLocal==selectedType">
        <div class="ui-g-12" *ngIf="contact.pbxOne.trim() != ''" style="padding-top: 0;">
          <div class="cardGray ui-g-12">
            <div class="ui-g-12" class="NoPadding">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <p class="info">{{fb.getStringRC('global_pbx_one')}}</p>
                  </div>
                </div>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <a href="tel:{{contact.pbxOne}}" >
                      <p class="result">{{contact.pbxOne}}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-12 p-grid" class="NoPadding">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <p class="info">{{fb.getStringRC('global_email_one')}}</p>
                  </div>
                </div>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <a href="mailto:{{contact.emailOne}}" >
                      <p class="result">{{contact.emailOne}}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-12" class="NoPadding">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <p class="info">Envia tu solicitud RPN (pdf):</p>
                  </div>
                </div>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <a href="mailto:{{contact.emailTwo}}" >
                      <p class="result">{{contact.emailTwo}}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-12" class="NoPadding">
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <p class="info">{{fb.getStringRC('global_web')}}</p>
                  </div>
                </div>
              </div>
              <div class="ui-g-12 ui-md-6 ui-lg-6">
                <div class="ui-g-12" class="NoPadding">
                  <div class="card ui-g-12">
                    <a href="https://{{contact.web}}" target="_blank" >
                      <p class="result">https://{{contact.web}}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="contact.observation.trim() != ''">
          <div class="card ui-g-12">
           <!-- <div class="ui-g-9 ui-md-6 ui-sm-12">
              <p style="color: #898A8F; font-weight: 400; font-family: poppins;">{{fb.getStringRC('global_web')}}</p>
            </div>-->
            <div class="ui-md-6">
              <a href="https://www.tecniseguros.com/" target="_blank">
                <h2>{{contact.observation}}</h2>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



